import Grid from '@mui/material/Grid';
import { TextField, MenuItem } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import dayjs from 'dayjs';

const FiltersSalesExecutive = ({
  dropdownValue,
  inputChange,
  options,
  displayDatepickers,
  setStartValue,
  startValue,
  setDropdownValue,
  setFromTime,
  endValue,
  setEndValue,
  setToTime,
}) => {
  return (
    <Grid size={{ xs: 12 }} className={'filters-container container-1 my-sales'}>
      <Grid container>
        <Grid size={{ xs: 6 }} className={'filter-container'}>
          <TextField
            variant='standard'
            select
            fullWidth
            label='*Fecha'
            placeholder='Seleccionar'
            id='monthFilter'
            name='monthFilter'
            value={dropdownValue || ''}
            onChange={(e) => inputChange(e)}
            className='m-tb-20 form-control customDropdown'
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root:hover': {
                '& > fieldset': {
                  borderColor: '#6C63FF',
                },
              },
              background: 'white',
            }}
          >
            {options?.map((option) => (
              <MenuItem key={option?.id} value={option?.id} className='customDropdownItem'>
                {option?.name} {option?.year}
              </MenuItem>
            ))}
            <MenuItem key={1} value={1}>
              {'Personalizado'}
            </MenuItem>
          </TextField>
        </Grid>
        <Grid size={{ xs: 6 }} className={displayDatepickers}>
          <Grid container>
            <Grid size={{ xs: 1 }}></Grid>
            <Grid size={{ xs: 4 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
                <DatePicker
                  value={startValue}
                  onChange={(newValue) => {
                    setStartValue(newValue);
                    setDropdownValue(1);
                    setFromTime(moment(newValue.format('YYYY-MM-DD')).format());
                  }}
                  maxDate={dayjs()}
                />
              </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 1 }}></Grid>
            <Grid size={{ xs: 4 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
                <DatePicker
                  value={endValue}
                  onChange={(newValue) => {
                    setEndValue(newValue);
                    setDropdownValue(1);
                    setToTime(moment(newValue.format('YYYY-MM-DD')).format());
                  }}
                  maxDate={dayjs()}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default FiltersSalesExecutive;
